import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { TreeNode } from 'primeng/api';
import { ModelType } from '@shared/constants/model-type.enum';

@Injectable({
  providedIn: 'root'
})
export class TreeService {

  constructor(private apiService: ApiService) { }

  getTreeData(): Observable<TreeNode[]> {
    return this.apiService.get('tree', ModelType.None);
  }    
}